import { Component, OnInit, OnDestroy, HostBinding } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { AdddAttributeDialogService } from './addd-attribute-dialog.service';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { SLLayer } from 'src/app/model/sl-layer';
import { AttributesService, AttStorageType } from 'src/app/model/api-services/attributes.service';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';

export type AddAttributeDialogInfo = {
	handler: AnyHandler;
	layer: SLLayer;

}
@Component({
	selector: 'app-add-attribute-entry',
	templateUrl: './add-attribute-dialog.component.html',
	styleUrls: ['./add-attribute-dialog.component.scss']
})
export class AddAttributeDialogEntryComponent implements OnInit {
	@HostBinding('class.work-view') workView = true;
	public handler: AnyHandler;
	public layer: SLLayer;
	public attributeName = '';
	public attributeAlias = '';
	public attributeDescription = '';
	public attributeDataType: AttStorageType = 'text';
	public title = 'Add a new attribute';
	constructor(private activeModal: NgbActiveModal, private messager: ModalMessagerService, private attSvc: AttributesService) { }

	Show(info: AddAttributeDialogInfo) {
		this.handler = info.handler;
		this.layer = info.layer;
		this.attributeName = '';
		this.attributeDescription = '';
		this.attributeDataType = 'text';

	}
	Ok() {
		this.messager.Notify('Adding new attribute ' + this.attributeName + ' to layer server-side', false, 'Creating Attribute...');
		this.attSvc.AddAttribute(this.layer,
			{ name: this.attributeName, type: this.attributeDataType }
		).then((results) => {
			this.messager.Ok('Creating Attribute...');
			this.handler(results);
			this.Close();
		});
	}
	Cancel() {
		this.Close();

	}
	Close() {
		this.activeModal.close();
	}
	ngOnInit() { }

}

@Component({
	selector: 'app-add-attribute-dialog',
	template: ''
})
export class AddAttributeDialogComponent implements OnDestroy {
	modalRef: NgbModalRef;
	subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
	lastTitle: string | null = null;

	constructor(private modalService: NgbModal, private service: AdddAttributeDialogService) {

		this.subscriptionMgr.Subscribe(this.service.request$, (info: AddAttributeDialogInfo) => {
			this.modalRef = this.modalService.open(AddAttributeDialogEntryComponent, { backdrop: 'static' });
			(this.modalRef.componentInstance as AddAttributeDialogEntryComponent).Show(info);
		});
	}
	ngOnDestroy() {
		this.subscriptionMgr.CancelSubscriptions();
	}
}

